import type { ActionRewardConfigStatus, ActionRewardExcludeColumn } from '~/services/LuxLoyalty';

import { objectKeys } from '~/utils/objectUtils';

export const ACTION_REWARD_CONFIG_STATUSES: ReadonlyArray<ActionRewardConfigStatus> = ['ACTIVE', 'INACTIVE'];

/** Exhaustive against the contract union so a new exclude column fails typecheck until it is listed. */
const ACTION_REWARD_EXCLUDE_COLUMN_KEYS: Record<ActionRewardExcludeColumn, true> = {
  downloadMobileApp: true,
  installMobileWidget: true,
  subscribeComms: true,
  addDateOfBirth: true,
  addPhoneNumber: true,
  addBusinessDetails: true,
};

export const ACTION_REWARD_EXCLUDE_COLUMNS = objectKeys(ACTION_REWARD_EXCLUDE_COLUMN_KEYS);

/** When allowRepeat is true, omit maxRepeat for unlimited; if set it must be at least 2. */
export const ACTION_REWARD_MIN_MAX_REPEAT = 2;
